document.addEventListener("DOMContentLoaded", function () {
    const headers = document.querySelectorAll(".custom-accordion-header");
    headers.forEach(header => {
        header.addEventListener("click", () => {
            const content = header.nextElementSibling;
            const isOpen = header.classList.contains("active");

            document.querySelectorAll(".custom-accordion-header").forEach(h => h.classList.remove("active"));
            document.querySelectorAll(".custom-accordion-content").forEach(c => c.style.maxHeight = null);

            if (!isOpen) {
                header.classList.add("active");
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
  const initMegaMenuAccordion = () => {
    // Only target the specific unique container
    const container = document.querySelector('.megamenu-items');
    if (!container || window.innerWidth < 768) return;

    const items = container.querySelectorAll('.MegaMenu__Item');

    items.forEach(item => {
      const subMenu = item.querySelector('.Linklist');
      const titleLink = item.querySelector('.MegaMenu__Title');

      // Only apply accordion if a submenu (Linklist) exists
      if (subMenu) {
        item.classList.add('has-accordion');

        titleLink.addEventListener('click', function(e) {
          e.preventDefault(); // Stop page jump
          e.stopPropagation();

          // Check if this item is already active
          const isActive = item.classList.contains('is-active');

          // Close all other accordions in this menu for a clean look
          items.forEach(otherItem => otherItem.classList.remove('is-active'));

          // Toggle the clicked one
          if (!isActive) {
            item.classList.add('is-active');
          }
        });
      }
    });
  };

  // Run on load
  initMegaMenuAccordion();
  
  // Optional: Re-check if window is resized
  window.addEventListener('resize', initMegaMenuAccordion);
});